module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.display) ? _c('div', {
    class: {
      'z-dialog': true, 'showed': _vm.showed
    }
  }, [_c('div', {
    staticClass: "z-dialog__shadow"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.close),
      expression: "close"
    }],
    class: {
      'z-dialog__window': true, 'showed': _vm.showed
    }
  }, [_c('div', {
    staticClass: "z-dialog__window__title"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "z-dialog__window__content"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "z-dialog__window__actions"
  }, [_vm._t("actions")], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-737d0de0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZDialog.vue
// module id = 1191
// module chunks = 0